/* eslint-disable react/forbid-prop-types */

import Box from '@zenbusiness/zui/Box';
import CircularProgress from '@zenbusiness/zui/CircularProgress';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';

import { QuestionLabelStyled } from './QuestionLabel.styles';

const QuestionLabel = ({ number, total, item }) => (
  <QuestionLabelStyled
    component="div"
    noLabel={item.noLabel}
    size="md"
  >
    {!item.noLabel && item.field.saved && !item.field.loading && (
      <CheckIcon
        aria-label={`Question number ${number} saved successfully`}
        color="background.green.main"
        fontSize="medium"
      />
    )}
    {!item.noLabel && item.field.loading && (
      <CircularProgress
        color="inherit"
        size={24}
      />
    )}
    {!item.noLabel && item.field.error && (
      <ClearIcon
        color="red"
        size={24}
      />
    )}
    <Text size="xs">{item.noLabel ? '' : ` Question ${number} of ${total}`}</Text>
  </QuestionLabelStyled>
);

QuestionLabel.propTypes = {
  number: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  item: PropTypes.shape({
    noLabel: PropTypes.bool,
    field: PropTypes.shape({
      saved: PropTypes.bool,
      loading: PropTypes.bool,
      error: PropTypes.bool,
      require: PropTypes.bool
    })
  })
};

export const Questions = ({ fields, dataChangeHandler = () => {}, data = {} }) => {
  const total = fields.filter((it) => !it.noLabel).length;
  return fields?.map((item, i) => (
    <Box key={`${item.field.key}_${i + 1}`}>
      <QuestionLabel
        item={item}
        number={i + 1}
        total={total}
      />
      {item.field.getEditField({ data, dataChangeHandler })}
    </Box>
  ));
};
Questions.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      noLabel: PropTypes.bool,
      field: PropTypes.shape({
        key: PropTypes.string,
        saved: PropTypes.bool,
        getEditField: PropTypes.func
      })
    })
  ),
  dataChangeHandler: PropTypes.func,
  data: PropTypes.object
};
